<template>
  <v-row>
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      class="mt--30"
      key="1"
    >
      <div class="rn-pricing">
        <div class="pricing-table-inner">
          <div class="pricing-header">
            <h4 class="heading-title">Estimates</h4>
            <div class="pricing">
              <span class="subtitle">Always</span>
              <span class="price">Free</span>
              <span class="subtitle">Give us a call</span>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      class="mt--30"
      v-for="pricing in pricingContent"
      :key="pricing.id"
    >
      <div class="rn-pricing" :class="{ active: pricing.active }">
        <div class="pricing-table-inner">
          <div class="pricing-header">
            <h4 class="heading-title">{{ pricing.title }}</h4>
            <div class="pricing">
              <span class="subtitle">from</span>
              <span class="price">{{ pricing.price.toFixed(2) }}</span>
              <span class="subtitle">{{ pricing.subtitle }}</span>
            </div>
          </div>

          <!-- <div class="pricing-body">
            <ul class="list-style--1">
              <li v-for="(singleList, i) in pricing.listItem" :key="i">
                <i class="fas fa-check"></i>{{ singleList.list }}
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        pricingContent: [
          {
            id: 2,
            title: "Tile Installation",
            price: 3.00,
            subtitle: "per sqft",
            active: false,
          },
          {
            id: 3,
            title: "Vinyl/Laminate Installation",
            price: 2.20,
            subtitle: "per sqft",
            active: false,
          },
        ],
      };
    },
  };
</script>
